import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe, I18NextService } from 'angular-i18next';
import { AlertComponent, ButtonComponent, FormGroupComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { ToastService } from 'mbs-ui-kit/toast/toast.service';
import { MbsPopupType } from 'mbs-ui-kit/utils/enums/mbs-popup-enum';
import { ComputerBackupFacade } from 'mbs-ui-shared@facades/computer.backup.facade';
import Computer from 'mbs-ui-shared@models/Computer';
import { ComputerPlanBasedModal } from 'mbs-ui-shared@models/ComputersModals';
import { PlanType } from 'mbs-ui-shared@models/PlanType';
import { PlanInfo } from 'mbs-ui-shared@models/backup/plan-info-model';
import { isBackupPlan } from 'mbs-ui-shared@utils/computer-utils';
import { of } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-delete-plan-modal',
  templateUrl: './delete-plan-modal.component.html',
  standalone: true,
  imports: [ButtonComponent, CommonModule, FormGroupComponent, AlertComponent, ModalComponent, I18NextPipe, ModalFooterDirective]
})
export class DeletePlanModalComponent implements ComputerPlanBasedModal, OnInit {
  i18nextService = inject(I18NextService);
  i18nPipe = inject(I18NextPipe);
  toast = inject(ToastService);
  private facade = inject(ComputerBackupFacade);
  private i18N = inject(I18NextPipe);

  public readonly alertType = MbsPopupType;
  public readonly planType = PlanType;

  public computer: Computer;
  public plan: PlanInfo;
  public loading = false;
  public mode: PlanType;

  @ViewChild(ModalComponent, { static: true }) private baseModal;

  ngOnInit() {
    this.mode = isBackupPlan(this.plan.type) ? PlanType.Backup : PlanType.Restore;
  }

  /**
   * Remove plan
   */
  handleResolve(): void {
    this.loading = true;
    const removePlanNotDefined = this.i18nPipe.transform('shared:computers.modals.removePlanNotDefined');

    this.facade
      .removePlan(this.computer, this.plan?.id)
      .pipe(
        map(() => true),
        catchError((e) => {
          // TODO Remove this when the method for deleting the plan is ready.
          if (e && e.error && e.error.message === removePlanNotDefined) {
            alert(removePlanNotDefined);
          }
          return of(false);
        }),
        tap(() => {
          this.loading = false;
        }),
        filter(Boolean)
      )
      .subscribe(() => {
        this.facade.loadPlans({ computer: this.computer, force: true });
        this.toast.success(this.i18N.transform('shared:computers.modals.deletePlanSuccessMessage', { planName: this.plan?.displayName }));
        this.baseModal.close();
      });
  }
}
